import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ProgramsPage from './pages/ProgramsPage';
import ProgramDetailPage from './pages/ProgramDetailPage';
import AICoursePage from './pages/AICoursePage';
import AboutPage from './pages/AboutPage';
import SuccessStoriesPage from './pages/SuccessStoriesPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import ResourcesPage from './pages/ResourcesPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import BootcampsPage from './pages/BootcampsPage';
import { Toaster } from './components/ui/toaster';

// CareerLift Menu Pages
import WhoWeHelpPage from './pages/WhoWeHelpPage';
import OurFrameworkPage from './pages/OurFrameworkPage';
import WhyStudentsFailPage from './pages/WhyStudentsFailPage';
import WhyChooseUsPage from './pages/WhyChooseUsPage';
import StudentSuccessPage from './pages/StudentSuccessPage';

// Dashboard Pages
import DashboardLogin from './pages/dashboard/DashboardLogin';
import DashboardHome from './pages/dashboard/DashboardHome';
import DashboardCourses from './pages/dashboard/DashboardCourses';
import DashboardMentor from './pages/dashboard/DashboardMentor';
import DashboardCertificates from './pages/dashboard/DashboardCertificates';

// Portfolio Project Pages
import ProjectAIChatbotPage from './pages/ProjectAIChatbotPage';
import ProjectMultiCloudPage from './pages/ProjectMultiCloudPage';
import ProjectCICDPage from './pages/ProjectCICDPage';
import ProjectAIAnalyticsPage from './pages/ProjectAIAnalyticsPage';
import ProjectKubernetesPage from './pages/ProjectKubernetesPage';
import AIBootcampPage from './pages/AIBootcampPage';
import AISolutionArchitectPage from './pages/AISolutionArchitectPage';
import ProductManagementAIPage from './pages/ProductManagementAIPage';
import WebinarsPage from './pages/WebinarsPage';
import AICareerRoadmapPage from './pages/AICareerRoadmapPage';
import CloudDevOpsPage from './pages/CloudDevOpsPage';
import SystemNetworkEngineerPage from './pages/SystemNetworkEngineerPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Main Website Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/ai-career-roadmap" element={<AICareerRoadmapPage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/programs/:programId" element={<ProgramDetailPage />} />
          <Route path="/programs/devops-engineer" element={<CloudDevOpsPage />} />
          <Route path="/programs/system-network-engineer" element={<SystemNetworkEngineerPage />} />
          <Route path="/courses/ai-career-launchpad" element={<AICoursePage />} />
          {/* Legacy route redirect */}
          <Route path="/ai-course" element={<AICoursePage />} />
          <Route path="/ai-bootcamp" element={<AIBootcampPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/success-stories" element={<SuccessStoriesPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:id" element={<BlogPostPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/bootcamps" element={<BootcampsPage />} />
          <Route path="/ai-solution-architect" element={<AISolutionArchitectPage />} />
          <Route path="/product-management-ai" element={<ProductManagementAIPage />} />
          <Route path="/webinars" element={<WebinarsPage />} />
          
          {/* CareerLift Menu Routes */}
          <Route path="/careerlift/who-we-help" element={<WhoWeHelpPage />} />
          <Route path="/careerlift/our-framework" element={<OurFrameworkPage />} />
          <Route path="/careerlift/student-success" element={<StudentSuccessPage />} />
          <Route path="/careerlift/why-students-fail" element={<WhyStudentsFailPage />} />
          <Route path="/careerlift/why-choose-us" element={<WhyChooseUsPage />} />
          
          {/* Portfolio Project Routes */}
          <Route path="/projects/ai-chatbot" element={<ProjectAIChatbotPage />} />
          <Route path="/projects/multi-cloud" element={<ProjectMultiCloudPage />} />
          <Route path="/projects/cicd-pipeline" element={<ProjectCICDPage />} />
          <Route path="/projects/ai-analytics" element={<ProjectAIAnalyticsPage />} />
          <Route path="/projects/kubernetes" element={<ProjectKubernetesPage />} />
          
          {/* Student Dashboard Routes */}
          <Route path="/dashboard" element={<DashboardLogin />} />
          <Route path="/dashboard/login" element={<DashboardLogin />} />
          <Route path="/dashboard/home" element={<DashboardHome />} />
          <Route path="/dashboard/courses" element={<DashboardCourses />} />
          <Route path="/dashboard/sessions" element={<DashboardHome />} />
          <Route path="/dashboard/certificates" element={<DashboardCertificates />} />
          <Route path="/dashboard/mentor" element={<DashboardMentor />} />
          <Route path="/dashboard/settings" element={<DashboardHome />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;